import React from 'react';
import { DQ_METRIC_KIND, EMPTY_DISPLAY } from '../constants/dataQuality';
import DataQualityDeltaBadge from './DataQualityDeltaBadge';

export default function DataQualityMetricWithImprovement({
  pct,
  improvementPct,
  metricKind = DQ_METRIC_KIND.VALID
}) {
  const displayPct = pct != null ? `${Number(pct).toFixed(2)}%` : EMPTY_DISPLAY;

  return (
    <div className="flex flex-col gap-0.5">
      <span className="font-medium text-gray-900">{displayPct}</span>
      {improvementPct != null ? (
        <DataQualityDeltaBadge value={improvementPct} metricKind={metricKind} />
      ) : (
        <span className="text-xs text-gray-400">no comparison</span>
      )}
    </div>
  );
}
